import * as React from 'react'
import './css/App.css';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js'
//Material web imports
import '@material/web/button/filled-button.js';
import '@material/web/button/text-button.js';
import '@material/web/button/filled-tonal-button'
import '@material/web/button/outlined-button.js';
import '@material/web/checkbox/checkbox.js';
import '@material/web/switch/switch.js'
import '@material/web/list/list';
import '@material/web/list/list-item'
import '@material/web/chips/chip-set'
import '@material/web/chips/assist-chip'
import '@material/web/fab/fab'
import '@material/web/chips/suggestion-chip'
import '@material/web/iconbutton/icon-button'
import '@material/web/iconbutton/filled-icon-button'
import '@material/web/iconbutton/outlined-icon-button'
import '@material/web/textfield/outlined-text-field.js'
import '@material/web/select/outlined-select.js'
import '@material/web/select/select-option.js'
//Material UI Imports
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';

//Local imports
import Notifications from './Components/Notifications';
import Tutorial from './Components/Tutorial';
import LoadingScreen from './Components/Loading';
import Login from './Components/Login';
import NavBar from './Components/Navbar';
import LeftSideBar from './Components/LeftSideBar';
import RightSideBar from './Components/RightSideBar';
import Content from './Components/Content';
import * as Default from './Themes/Default';
import * as Groovilicious from './Themes/Groovilicious';
import * as Foliage from './Themes/Foliage'
import * as Panther from './Themes/Panther'
import * as Yoyo from './Themes/Yoyo'
import * as Nouvelle from './Themes/Nouvelle'
import * as Plain from './Themes/Plain'
import './Themes/Default.css'
import './Themes/Nouvelle.css'
import './Themes/Groovilicious.css'
import './Themes/Foliage.css'
import './Themes/Panther.css'
import './Themes/Plain.css'
import './Themes/Yoyo.css'
import { Snackbar } from '@mui/material';

function App() {
  
  
  const [errorScreen, setErrorScreen] = React.useState(false)
  const [errorTitle, setErrorTitle] = React.useState('Error');
  const [errorMessage, setErrorMessage] = React.useState('Error');
  
  const handleErrorClose = () => setErrorScreen(false);
  const errorStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid primary.main',
    boxShadow: 24,
    p: 4,
  };
  
const generateRandomString = (length) => {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    result += charset.charAt(randomIndex);
  }
  return result;
};
  const generateSessionId = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  };
  //Theme
  const [colorTheme, setColorTheme] = React.useState('nouvelle')
  const [darkBg, setDarkBg] = React.useState(Default.darkBg);
  const [darkTxt, setDarkTxt] = React.useState(Default.darkTxt); 
  const [lightBg, setLightBg] = React.useState(Default.lightBg);
  const [lightTxt, setLightTxt] = React.useState(Default.lightTxt); 
  const [lightTheme, setLightTheme] = React.useState(Default.lightTheme);
  const [darkTheme, setDarkTheme] = React.useState(Default.darkTheme); React.useEffect(() => {
    const themes = {
      'default': Default,
      'groovilicious': Groovilicious,
      'foliage': Foliage,
      'panther': Panther,
      'yoyo': Yoyo,
      'plain': Plain,
      'nouvelle': Nouvelle
    };
  
    const removeClasses = ['default', 'groovilicious', 'foliage', 'panther', 'yoyo' ,'plain', 'nouvelle'];
  
    removeClasses.forEach(className => document.body.classList.remove(className));
  
    const selectedTheme = themes[colorTheme] || Default;
  
    document.body.classList.add(colorTheme);
    setDarkBg(selectedTheme.darkBg);
    setDarkTxt(selectedTheme.darkTxt);
    setLightBg(selectedTheme.lightBg);
    setLightTxt(selectedTheme.lightTxt);
    setLightTheme(selectedTheme.lightTheme);
    setDarkTheme(selectedTheme.darkTheme);
  }, [colorTheme]);
  //Loader 
  const [contentLoader, setContentLoader] = React.useState(false);
  //Tutorial
  const [tutorialStage, setTutorialStage] = React.useState(0);
  const [tutorialActive, setTutorialActive] = React.useState(false);
  //Tabs
  
  const [tabs, setTabs] = React.useState([{ label: "Home" , target: '/'}]);
  const [value, setValue] = React.useState(0);
  const [allCarets, setAllCarets] = React.useState([])
  const [colorScheme, setColorScheme] = React.useState('light');
  const [theme, setTheme] = React.useState(lightTheme);
  const [isDarkMode, setIsDarkMode] = React.useState(false);
  const [lowPower, setLowPower] = React.useState(false);
  const [rightSidebarContent, setRightSidebarContent] = React.useState('FileView')
  const [bgColor, setBgColor] = React.useState(lightBg);
  const [txtColor, setTxtColor] = React.useState(lightTxt);
  const [selectBg, setSelectBg] = React.useState(lightTheme.palette.primary.main)
  const [selectColor, setSelectColor] = React.useState(lightTheme.palette.primary.contrastText)
  const [scrollBarColor, setScrollBarColor] = React.useState(lightTheme.palette.surface.variant)
  //Sidebar states
  const [leftSideBar, setLeftSideBar] = React.useState(true);
  const [rightSideBar, setRightSideBar] = React.useState(false);
  const [rightSidebarWidth, setRightSidebarWidth] = React.useState(500);
  const [rightSidebarHeight, setRightSidebarHeight] = React.useState(200);
  const [initial, setInitial] = React.useState(0);
  const [mouseDown, setMouseDown] = React.useState(false);
  const [inSpace, setInSpace] = React.useState(false)
  const [showResize, setShowResize] = React.useState('');

  //User states
  const [loggedIn, setLoggedIn] = React.useState(false)
  const [username, setUsername] = React.useState('')
  const [uid, setUid] = React.useState('');
  
  const [showContent, setShowContent] = React.useState(false)
  React.useEffect(()=>{
    if(loggedIn) {
      const displayContentTimeOut = setTimeout(()=>{
        setShowContent(true)
      }, 1500)
      return () => clearTimeout(displayContentTimeOut)
    }else {
      setShowContent(false)
    }
  }, [loggedIn])
  const [globalSnackbarActive, setGlobalSnackbarActive] = React.useState(false)
  const [globalSnackbar, setGlobalSnackbar] = React.useState('');
  //File states
  const [allFiles, setAllFiles] = React.useState([])
  const [storageUsage, setStorageUsage] = React.useState(0)
  const [globalNoteContent, setGlobalNoteContent] = React.useState(null)
  const [globalBoardContent, setGlobalBoardContent] = React.useState(null)
  const [globalBoardImages, setGlobalBoardImages] = React.useState(null)
  const [globalBoardContentFromOthers, setGlobalBoardContentFromOthers] = React.useState(null)
  const [globalNoteContentFromOthers, setGlobalNoteContentFromOthers] = React.useState(null)
  const [globalEditors, setGlobalEditors] = React.useState([])
  //Server states
  const [loadingScreen, setLoadingScreen] = React.useState(true)
  const [init, setInit] = React.useState(false)
  const [sessionId, setSessionId] = React.useState(null)
  const [clientId, setClientId] = React.useState(null)
  const [clearLogin, setClearLogin] = React.useState('false');
  const mainVersion = 'beta-v8-patch-8.0'
  const addr = 'https://donotes-server.com'
  //const addr = 'http://194.164.24.85'
  //const addr = 'http://localhost'
  const [editorInit, setEditorInit] = React.useState(false)
  //Encryption states
  //Note states
  const [noteSync, setNoteSync] = React.useState(null)
  React.useEffect(()=>{
    console.clear()
    console.log(`%c
    ██████╗  ██████╗ ███╗   ██╗ ██████╗ ████████╗███████╗███████╗
    ██╔══██╗██╔═══██╗████╗  ██║██╔═══██╗╚══██╔══╝██╔════╝██╔════╝
    ██║  ██║██║   ██║██╔██╗ ██║██║   ██║   ██║   █████╗  ███████╗
    ██║  ██║██║   ██║██║╚██╗██║██║   ██║   ██║   ██╔══╝  ╚════██║
    ██████╔╝╚██████╔╝██║ ╚████║╚██████╔╝   ██║   ███████╗███████║
    ╚═════╝  ╚═════╝ ╚═╝  ╚═══╝ ╚═════╝    ╚═╝   ╚══════╝╚══════╝
                                                                 `,  "color: skyblue")
  console.log(`We will never ask you to copy anything from here!`)
  }, [])
  //Server Init Phase Request
  React.useEffect(()=>{
    let time = 30
    const refresh = setInterval(()=>{
      time = time - 1;
      if(time === 0) {
        async function pingAccountSerer() {
          let endpoint = 'https://donotes-server.com:7070'
            
          const agent = window.navigator.userAgent;
            try {
                
              const fetchReq = {
                type: 'fetch-data',
                sessionId,
                clientId,
                agent,
              }
              const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(fetchReq)
              })
              if(!response.ok ) {
                throw new Error('Network response was not ok');                  
              }
              const responseData = await response.json();
              if(responseData && responseData.type) {
                if(responseData.type === 'data-from-server') {
                  try {
                    
                    setAllFiles(JSON.parse(responseData.payload))
                    const storage = JSON.parse(responseData.accountSize)
                    setStorageUsage(storage[0].storage)
                  }catch(error) {
                    console.error(error)
                  }
                }else if(response.message) {
                  //todo snackbar
                  //setOpenSnackbar(true)
                  //setSnackbarMessage(response.message)
                }
              }
            }
            catch(error) {
              console.error(error)
            }
        }
        pingAccountSerer()
        time = 30;
      }
    }, 1000)
    return () => clearInterval(refresh)
  }, [])
  
  async function initPhase() {
    if(1 === 1) {
      
      try {
        const endpoint = `${addr}:9090`
        const agent = window.navigator.userAgent;
        const message = {
          type: 'initialisation',
          version: mainVersion,
          agent
        }
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(message)
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        // If you need to handle the response
        const responseData = await response.json();
        if(responseData.sessionId && responseData.clientId) {
          
          setSessionId(responseData.sessionId)
          setClientId(responseData.clientId)
        }else {
          window.reload()
        }
        if(responseData.type === 'success' && responseData.extra === 'fetch-user-info') {
          
          
          let endpoint = `${addr}:7070`
          try {
              
            const fetchReq = {
              type: 'fetch-data',
              sessionId,
              clientId,
              agent,
            }
            const response = await fetch(endpoint, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(fetchReq)
            })
            if(!response.ok ) {
              throw new Error('Network response was not ok');                  
            }
            const responseData = await response.json();
            if(responseData && responseData.type) {
              if(responseData.type === 'reload') {
                sessionStorage.clear()
                window.location.reload()
              }
              if(responseData.type === 'data-from-server') {
                try {
                  setUsername(responseData.username)
                  setAllFiles(JSON.parse(responseData.payload))
                  const storage = JSON.parse(responseData.accountSize)
                  setStorageUsage(storage[0].storage)
                  setLoggedIn(true)
                }catch(error) {
                  console.error(error)
                }
              }else if(responseData.message) {
                //todo snackbar
                //setOpenSnackbar(true)
                //setSnackbarMessage(response.message)
              }
            }
          }
          catch(error) {
            console.error(error)
          }
        } 
        setLoadingScreen(false)
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }
  React.useEffect(()=>{
    
    const clientId = generateRandomString(128)
    setClientId(clientId)
    async function initPhase() {
      if(clientId && sessionId) {
        
        try {
          const endpoint = `${addr}:9090`
          const agent = window.navigator.userAgent;
          const message = {
            type: 'initialisation',
            version: mainVersion,
            clientId,
            sessionId,
            agent
          }
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(message)
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          // If you need to handle the response
          const responseData = await response.json();
          if(responseData.type === 'success' && responseData.extra === 'fetch-user-info') {
            
            
            let endpoint = `${addr}:7070`
            try {
                
              const fetchReq = {
                type: 'fetch-data',
                sessionId,
                clientId,
                agent,
              }
              const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(fetchReq)
              })
              if(!response.ok ) {
                throw new Error('Network response was not ok');                  
              }
              const responseData = await response.json();
              if(responseData && responseData.type) {
                if(responseData.type === 'reload') {
                  sessionStorage.clear()
                  window.location.reload()
                }
                if(responseData.type === 'data-from-server') {
                  try {
                    setUsername(responseData.username)
                    setAllFiles(JSON.parse(responseData.payload))
                    const storage = JSON.parse(responseData.accountSize)
                    setStorageUsage(storage[0].storage)
                    setLoggedIn(true)
                  }catch(error) {
                    console.error(error)
                  }
                }else if(responseData.message) {
                  //todo snackbar
                  //setOpenSnackbar(true)
                  //setSnackbarMessage(response.message)
                }
              }
            }
            catch(error) {
              console.error(error)
            }
          } 
          setLoadingScreen(false)
        } catch (error) {
          console.error('Error:', error);
        }
      }
    }
    initPhase()
  }, [sessionId])
  
  
  //Log out script
  
  
  function LogOut() {
    //Log out function
    
    sessionStorage.clear('sessid')
    window.location.reload()
  }
  //Session ID Fetch
  React.useEffect(() => {
    const checkTabs = Cookies.get('tabs');
    try {
      const parsedTabs = JSON.parse(checkTabs)
      let pass = true;
      parsedTabs.forEach((row)=>{
        if(!row.label && !row.target) {
          pass = false
        }
      })
      if(pass === true) {
        setTabs(parsedTabs)
      }
    }catch(error) {
      console.error(error)
    }
    
    const val = parseInt(Cookies.get('tab'))
    setValue(val)
    const checkSession = sessionStorage.getItem('sessid');

    if (!checkSession) {
      const newSession = generateSessionId();
      
    if(window.location.hostname === 'v8.donotes.app') {
      
      sessionStorage.setItem('sessid', newSession);
    }else {
      
      sessionStorage.setItem('sessid', newSession);
    }
      setSessionId(newSession);
      
    }else {
      setSessionId(sessionStorage.getItem('sessid') )
    }
    
    const checkTheme = Cookies.get('theme') !== undefined;

    if (!checkTheme || checkTheme == '') {
      Cookies.set('theme', 'default', { expires: 7 });
      
    }else {
      setColorTheme(Cookies.get('theme') )
      
    }
  }, []);
  React.useEffect(()=>{
    
    Cookies.set('theme', colorTheme, { expires: 7 });
  }, [colorTheme])

  
  React.useEffect(()=>{
    const tab = JSON.stringify(tabs)
    Cookies.set('tabs', tab, { expires: 7 });
  }, [tabs])
  
  React.useEffect(()=>{
    Cookies.set('tab', value, { expires: 7 });
  }, [value])

  // Encrypt function
  const encrypt = (text, privateKey, public_key) => {
    const encrypted = CryptoJS.AES.encrypt(text, CryptoJS.enc.Hex.parse(privateKey), {
      iv: CryptoJS.enc.Hex.parse(public_key),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();

    return encrypted;
  };

  // Decrypt function
  const decrypt = (text, privateKey, public_key) => {
    const decrypted = CryptoJS.AES.decrypt(text, CryptoJS.enc.Hex.parse(privateKey), {
      iv: CryptoJS.enc.Hex.parse(public_key),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString(CryptoJS.enc.Utf8);

    return decrypted;
  };
  React.useEffect(() => {
    return
      const handleMouseMove = (e) => {
        
        if(mouseDown && inSpace) {
          const newX = -1 * (e.pageX - initial)
          setRightSidebarWidth(rightSidebarWidth + newX)
        setInitial(e.pageX)
        setShowResize('show-resize');
        document.body.classList.add('resize-cursor')
      }
      };
  
      const handleMouseDown = () => {
        setMouseDown(true);
        setMouseDown(true)
        setShowResize('');
        document.body.classList.remove('resize-cursor')
      };
  
      const handleMouseUp = () => {
        setShowResize('');
        document.body.classList.remove('resize-cursor')
        setInSpace(false)
        setMouseDown(false);
        setMouseDown(false)
      };
  
      // Attach event listeners to the document
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mousedown', handleMouseDown);
      document.addEventListener('mouseup', handleMouseUp);
  
      // Cleanup the event listeners on component unmount
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mousedown', handleMouseDown);
        document.removeEventListener('mouseup', handleMouseUp);
      };
    }, [mouseDown, rightSidebarWidth]);
  React.useEffect(()=>{
    if(colorScheme === 'light') {
      setTheme(lightTheme);
      setBgColor(lightBg)
      setTxtColor(lightTxt)

      document.body.classList.add('light')
      document.body.classList.remove('dark')
    }else {
      setTheme(darkTheme);
      setBgColor(darkBg)
      setTxtColor(darkTxt)
      document.body.classList.add('dark')
      document.body.classList.remove('light')
    }
  }, [colorScheme, darkBg])
  
  React.useEffect(()=>{
    setSelectBg(theme.palette.primary.main)
    setScrollBarColor(theme.palette.surface.variant)
    setSelectColor(theme.palette.primary.contrastText)
  }, [theme])
  React.useEffect(() => {
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleColorSchemeChange = (event) => {
      setIsDarkMode(event.matches);
    };
    darkModeMediaQuery.addEventListener('change', handleColorSchemeChange);
    setIsDarkMode(darkModeMediaQuery.matches);
    return () => {
      darkModeMediaQuery.removeEventListener('change', handleColorSchemeChange);
    };
  }, []);
  React.useEffect(()=>{
    const dark = isDarkMode
    if(dark) {
      setColorScheme('dark');
      document.body.classList.add('dark')
      document.body.classList.remove('light')
    }else {
      setColorScheme('light')
      document.body.classList.add('light')
      document.body.classList.remove('dark')
    }
  }, [isDarkMode])
  function findNameById(array, parentId) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].id === parentId) {
        return array[i].name;
      }
    }
    // Return null if no match is found
    return null;
    
  }
  
  const updateTab = (index, label, target) => {
    const updatedTabs = [...tabs];
    updatedTabs[index] = { label, target };
    setTabs(updatedTabs);
  };
  function findNotePath(noteId) {
    let parentIdToSearch = null;
    for (let i = 0; i < allFiles.length; i++) {
      if (allFiles[i].id === noteId) {
        parentIdToSearch = allFiles[i].parent
        if(parentIdToSearch === '-1') {
          return [`Shared by ${allFiles[i].username}`]
        }
      }
    }
    let returnFolders = []
    while (parentIdToSearch !== 0 && parentIdToSearch !== null) {
      let found = false;
      for (let i = 0; i < allFiles.length; i++) {
        if (allFiles[i].id === parentIdToSearch) {
          found = true
          returnFolders.push(allFiles[i].name)
          parentIdToSearch = allFiles[i].parent
        }
      }
      if(found === false) {
        parentIdToSearch = 0
      }
    }
    
    return returnFolders
  }
  //console.log('App reinit')
  return (
    <ThemeProvider 
      theme={theme}
    >
      <CssBaseline />
      {loadingScreen && 
        <LoadingScreen 
          setLoadingScreen={setLoadingScreen} 
          loadingScreen={loadingScreen} 
        />}
      {!loggedIn && 
        <Login 
          setGlobalSnackbar={setGlobalSnackbar}
          setGlobalSnackbarActive={setGlobalSnackbarActive}
          addr={addr}
          clearLogin={clearLogin}  
          setStorageUsage={setStorageUsage}
          sessionId={sessionId} 
          clientId={clientId} 
          setUn={setUsername}
          encrypt={encrypt} 
          loggedIn={loggedIn} 
          setLoggedIn={setLoggedIn} 
          setAllFiles={setAllFiles}
        />
      }
      {loggedIn && <Notifications isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} initPhase2={initPhase} setAllFiles={setAllFiles} LogOut={LogOut} clientId={clientId} sessionId={sessionId} addr={addr} mainVersion={mainVersion} />}
      <div 
        className={ `App ${colorScheme} ${colorTheme} ${lowPower && 'low-power'}` }
      >
        <NavBar 
          theme={theme} 
          setTabs={setTabs}  
          setValue={setValue} 
          value={value} 
          tabs={tabs} 
          LogOut={LogOut} 
          setColorScheme={setColorScheme} 
          colorScheme={colorScheme} 
          setLeftSideBar={setLeftSideBar} 
          setRightSideBar={setRightSideBar} 
          rightSideBar={rightSideBar}
        />
        <div className='content' style={{maxWidth: '100%'}}>
          <LeftSideBar 
            mainVersion={mainVersion}
            setStorageUsage={setStorageUsage}
            setContentLoader={setContentLoader} 
            colorTheme={colorTheme} 
            setColorTheme={setColorTheme}  
            storageUsage={storageUsage}
            theme={theme} 
            setTabs={setTabs}  
            setValue={setValue} 
            value={value} 
            tabs={tabs} 
            LogOut={LogOut} 
            setColorScheme={setColorScheme} 
            colorScheme={colorScheme}  
            setLeftSideBar={setLeftSideBar} 
            encrypt={encrypt}  
            clientId={clientId}  
            sessionId={sessionId} 
            loggedIn={loggedIn} 
            addr={addr}
            username={username} 
            setLowPower={setLowPower} 
            lowPower={lowPower} 
            leftSideBar={leftSideBar}
            allFiles={allFiles}
            setAllFiles={setAllFiles}
          />
          {showContent && 
            <Content  
              addr={addr}
              globalBoardContentFromOthers={globalBoardContentFromOthers} 
              globalBoardImages={globalBoardImages} 
              globalBoardContent={globalBoardContent} 
              setGlobalBoardContent={setGlobalBoardContent} 
              setContentLoader={setContentLoader} 
              loggedIn={loggedIn} 
              noteSync={noteSync} 
              setNoteSync={setNoteSync} 
              allCarets={allCarets} 
              allFiles={allFiles}
              globalEditors={globalEditors} 
              globalNoteContentFromOthers={globalNoteContentFromOthers} 
              findNotePath={findNotePath} 
              findNameById={findNameById} 
              updateTab={updateTab} 
              value={value} 
              encrypt={encrypt} 
              setEditorInit={setEditorInit} 
              editorInit={editorInit} 
              loadingScreen={init} 
              setGlobalNoteContent={setGlobalNoteContent} 
              globalNoteContent={globalNoteContent} 
              clientId={clientId}  
              sessionId={sessionId}  
              scrollBarColor={scrollBarColor} 
              selectColor={selectColor}  
              selectBg={selectBg} 
              username={username} 
              colorTheme={colorTheme} 
              bgColor={bgColor} 
              txtColor={txtColor} 
              theme={theme} 
              colorScheme={colorScheme} 
            />}
          <RightSideBar  
            theme={theme} 
            colorTheme={colorTheme} 
            setColorTheme={setColorTheme} 
            showResize={showResize} 
            setInSpace={setInSpace} 
            inSpace={inSpace} 
            setInitial={setInitial} 
            setMouseDown={setMouseDown} 
            mouseDown={mouseDown}  
            initial={initial} 
            rightSidebarWidth={rightSidebarWidth} 
            setRightSidebarWidth={setRightSidebarWidth} 
            rightSidebarHeight={rightSidebarHeight} 
            setRightSidebarHeight={setRightSidebarHeight} 
            rightSidebarContent={rightSidebarContent} 
            setRightSidebarContent={setRightSidebarContent} 
            rightSideBar={rightSideBar} 
          />
        </div>
      </div>
      <Snackbar
        open={globalSnackbarActive}
        
        autoHideDuration={4000}
        onClose={()=>{setGlobalSnackbarActive(false)}}
        message={globalSnackbar}
        />
      <Backdrop
        sx={{ color: '#fff', zIndex: 3}}
        open={contentLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={errorScreen}
        onClose={handleErrorClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={errorScreen}>
          <Box sx={errorStyle}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              {errorTitle}
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              {errorMessage}
            </Typography>
          </Box>
        </Fade>
      </Modal>
      {tutorialActive && 
      <Tutorial setTutorialActive={setTutorialActive} setTutorialStage={setTutorialStage} tutorialStage={tutorialStage}/>}
    </ThemeProvider>
  );
}

export default App;
